import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { makeStyles, ThemeProvider } from '@material-ui/core/styles';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => (styles(theme)));

const styles = (theme) => {

    return ({
        dialog: {
            "& .MuiDialog-paper": {
                margin: '0 !important'
            },

        },
    })

}

export default function SlideInModal({ children, openModal, header }) {
    const [open, setOpen] = React.useState(openModal);
    const classes = useStyles();

    useEffect(() => {
        setOpen(openModal)
    }, [openModal])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>

            <Dialog
                className={classes.dialog}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                fullWidth={true}
                maxWidth='md'
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    {children}
                </DialogContent>

            </Dialog>
        </div>
    );
}